export const CONSENTS_SAVED = 'consentsSaved';
